import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

//import img
import causesImg from '../../assets/icons/arrow-circle-full-yellow.svg';
import sorryImg from '../../assets/icons/arrow-circle-full-green.svg';

const NewsNoResults = ({clang}) => {
    return (
      <div className="news__no-results">
            <h2 className="news__no-results--title">{lang[clang].news.no_results_title}</h2>
            <div className="news__no-results--separator"></div>
            <span className="news__no-results--causes">
                <img className="news__no-results--causes-img" src={causesImg} alt=""/>
                {lang[clang].errors.error_info}
            </span>
            <div className="news__no-results--what-now-container">
                <p dangerouslySetInnerHTML={{__html: lang[clang].news.no_results_suggestions}}></p>
            </div>
            <h3 className="news__no-results--sorry">
                <img className="news__no-results--sorry-img" src={sorryImg} alt=""/>
                {lang[clang].errors.sorry}
            </h3>
            <div className="news__no-results--what-now-container">
                <p className="news__no-results--what-now">{lang[clang].errors.what_now}</p>
                <Link to={`/news/all`} className="error-page--link" title={lang[clang].news.no_results_all_news}>{lang[clang].news.no_results_all_news}</Link>
                <span className="error-page--what-now-separator">|</span>
                <span className="error-server__use-map">{lang[clang].news.no_results_change_query}</span>
            </div>
        </div>
    );
};

NewsNoResults.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(NewsNoResults);



// WEBPACK FOOTER //
// ./src/components/news/NewsNoResults.js